import { render } from "./InvoicesSearchFilters.vue?vue&type=template&id=04f8a165"
import script from "./InvoicesSearchFilters.vue?vue&type=script&lang=js"
export * from "./InvoicesSearchFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__